// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"9c59f862","166":"80f78b37","474":"e162d5c6","787":"0254b236"}[chunkId] + ".chunk.js";
};